import { render, staticRenderFns } from "./FacebookModal.vue?vue&type=template&id=06bbd684&"
import script from "./FacebookModal.vue?vue&type=script&lang=js&"
export * from "./FacebookModal.vue?vue&type=script&lang=js&"
import style0 from "./FacebookModal.vue?vue&type=style&index=0&id=06bbd684&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bbd684')) {
      api.createRecord('06bbd684', component.options)
    } else {
      api.reload('06bbd684', component.options)
    }
    module.hot.accept("./FacebookModal.vue?vue&type=template&id=06bbd684&", function () {
      api.rerender('06bbd684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/campaign/EditCampaign/FacebookModal.vue"
export default component.exports